// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Login.css */

.login-container {
  display: flex;
  flex-direction: column;
  background-color: #00081a;
  height: 96vh;
  border-radius: 3em;
  justify-content: space-around;
  align-items: center;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}


.facialbutton {
  background-color: #007aff;
    color: white;
    padding: 15px;
    padding-left: 45px;
    padding-right: 45px;
    border: none;
    border-radius: 10px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.noaccounttext{
  color: white;
}

.loginimage {
  max-width: 15em;
  transition: transform 0.3s ease; 
}

.login-container h2 {
  color: white;
  margin-bottom: 30px;
  font-size: xx-large;
}

.login-container form {
  display: flex;
  flex-direction: column;
  width: 80%;
  gap: 15px;
  align-items: center;
}

.login-container form div {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.login-container form label {
  margin-bottom: 5px;
  color: #007aff;
  font-weight: 600;
}

.login-container form input {
  padding: 10px;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 10px;
  font-size: 16px;
  background: #fff;
}

.login-container form button {
  background-color: #007aff;
  color: white;
  padding: 15px;
  padding-left: 45px;
  padding-right: 45px;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.login-container form button:hover {
  background-color: #005ecb;
}

/* Add any other specific styles you need */


/* Media query for small screens like the iPhone SE */
@media (max-width: 375px) {


.loginimage {
  max-width: 5em;
}

}
`, "",{"version":3,"sources":["webpack://./src/components/css/Login.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,uGAAuG;AACzG;;;AAGA;EACE,yBAAyB;IACvB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,iCAAiC;AACrC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2CAA2C;;;AAG3C,qDAAqD;AACrD;;;AAGA;EACE,cAAc;AAChB;;AAEA","sourcesContent":["/* Login.css */\n\n.login-container {\n  display: flex;\n  flex-direction: column;\n  background-color: #00081a;\n  height: 96vh;\n  border-radius: 3em;\n  justify-content: space-around;\n  align-items: center;\n  padding: 20px;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n}\n\n\n.facialbutton {\n  background-color: #007aff;\n    color: white;\n    padding: 15px;\n    padding-left: 45px;\n    padding-right: 45px;\n    border: none;\n    border-radius: 10px;\n    font-size: 16px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n}\n\n.noaccounttext{\n  color: white;\n}\n\n.loginimage {\n  max-width: 15em;\n  transition: transform 0.3s ease; \n}\n\n.login-container h2 {\n  color: white;\n  margin-bottom: 30px;\n  font-size: xx-large;\n}\n\n.login-container form {\n  display: flex;\n  flex-direction: column;\n  width: 80%;\n  gap: 15px;\n  align-items: center;\n}\n\n.login-container form div {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.login-container form label {\n  margin-bottom: 5px;\n  color: #007aff;\n  font-weight: 600;\n}\n\n.login-container form input {\n  padding: 10px;\n  width: 100%;\n  border: 1px solid #ccc;\n  border-radius: 10px;\n  font-size: 16px;\n  background: #fff;\n}\n\n.login-container form button {\n  background-color: #007aff;\n  color: white;\n  padding: 15px;\n  padding-left: 45px;\n  padding-right: 45px;\n  border: none;\n  border-radius: 10px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.login-container form button:hover {\n  background-color: #005ecb;\n}\n\n/* Add any other specific styles you need */\n\n\n/* Media query for small screens like the iPhone SE */\n@media (max-width: 375px) {\n\n\n.loginimage {\n  max-width: 5em;\n}\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
